import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-loading-spinner',
  imports: [],
  standalone: true,
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css'],
})
export class LoadingSpinnerComponent {
  @Input() text: String;
}
